// extracted by mini-css-extract-plugin
export default {"label":"acceptLateWithdrawal_label__5pJ+b","btnContainer":"acceptLateWithdrawal_btnContainer__4feso","error":"acceptLateWithdrawal_error__6clnq"};